// extracted by mini-css-extract-plugin
module.exports = {"theme":"#0a906c"};